import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';

import Message from '@/forms/Validations/Message';

import { BrochureRequestFormModel, names } from './BrochureRequestForm.types';

import FormValidationMixin from '@/forms/FormElements/Mixins/FormValidationMixin';

import NameRow from '@/forms/FormElements/Rows/NameRow/NameRow.vue';
import EmailRow from '@/forms/FormElements/Rows/EmailRow/EmailRow.vue';
import AddressRow from '@/forms/FormElements/Rows/AddressRow/AddressRow.vue';
import PhoneRow from '@/forms/FormElements/Rows/PhoneRow/PhoneRow.vue';
import TCRow from '@/forms/FormElements/Rows/TermsAndConditionsRow/TermsAndConditionsRow.vue';
import CheckBoxRow from '@/forms/FormElements/Rows/CheckBoxRow/CheckBoxRow.vue';
import ButtonRow from '@/forms/FormElements/Rows/ButtonRow/ButtonRow.vue';
import AccordionItem from '@/components/AccordionItem/AccordionItem.vue';
import FormWrapper from '@/forms/FormElements/Common/FormWrapper/FormWrapper.vue';
import { FormWrapperLayoutModel } from '@/forms/FormElements/Common/FormWrapper/FormWrapper.type';

import SelectItem from '@/common/interfaces/SelectItem';

import getValidation from './BrochureRequestForm.validations';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import NewsletterOptinMixin from '@/forms/FormElements/Mixins/NewsletterOptinMixin';
import { DISNEY_OPTIN_HTML } from '@/utils/contentConst';
import { isUSAIP } from '@/store';

const { validations, model, messages } = getValidation();

@Component({
  validations,
  components: {
    NameRow,
    EmailRow,
    AddressRow,
    PhoneRow,
    TCRow,
    CheckBoxRow,
    ButtonRow,
    AccordionItem,
    FormWrapper,
  },
  data: () => {
    return {
      FormWrapperLayoutModel,
    };
  },
})
export default class BrochureRequestForm extends mixins(FormValidationMixin, StoreModuleMixin, NewsletterOptinMixin) {
  @Prop({ type: Array as () => SelectItem[] })
  readonly brochures!: SelectItem[];
  @Prop()
  readonly TermsLink!: string;
  @Prop()
  readonly PrivacyPolicyLink!: string;
  @Prop(Boolean)
  readonly IsBtB!: boolean;
  @Prop() readonly bottomText!: string;

  model: BrochureRequestFormModel = model;
  messages: Message[] = messages;

  names = names;

  USASelected = false;

  setCountryName(option: SelectItem) {
    this.USASelected = option.Value === 385
    this.model.Address.CountryName = option.data.Alpha2;
  }

  disneyOptinContent = DISNEY_OPTIN_HTML;

  get isUSAGeo() {
    return isUSAIP()
  }
}
